<template>
  <div>
    <button class="active-button">
      <slot />
    </button>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
